import { render, staticRenderFns } from "./DebtorListListSideMenu.vue?vue&type=template&id=63f9f4ed"
import script from "./DebtorListListSideMenu.vue?vue&type=script&lang=js"
export * from "./DebtorListListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports